import { BodyText, HeadlineText } from "@classdojo/web/nessie";
import { ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { Lesson, Slide } from "src/pods/ideas/data/types";

export default function Watch({
  lesson,
  watch,
  timing,
  onClick,
}: {
  watch: Slide;
  lesson: Lesson;
  timing?: string;
  onClick: VoidFunction;
}) {
  if (watch.type !== "hls") return null;

  return (
    <div sx={lessonCardStyle(watch)} onClick={onClick}>
      <div sx={lessonCardWatchDivStyle}>
        <HeadlineText as="h3" kind="light" sx={lessonCardWatchDivH3Style}>
          {lesson.title}
        </HeadlineText>

        {timing ? (
          <BodyText kind="light" sx={lessonCardWatchDivSpanStyle}>
            {timing}
          </BodyText>
        ) : (
          <BodyText kind="light" sx={lessonCardWatchDivSpanStyle}>
            3 minute video
          </BodyText>
        )}
      </div>
    </div>
  );
}

const lessonCardWatchDivSpanStyle: ThemeUIStyleObject = {
  textShadow: "0 1px 1px rgba(0, 0, 0, 0.4)",
  marginTop: "dt_xxs",
};

const lessonCardWatchDivH3Style: ThemeUIStyleObject = {
  textShadow: "0 1px 1px rgba(0, 0, 0, 0.4)",
};

const lessonCardWatchDivStyle: ThemeUIStyleObject = {
  zIndex: 2,
  position: "absolute",
};

function lessonCardStyle(watch: Slide): ThemeUIStyleObject {
  return {
    boxShadow: "dt_shadow_shadezies_small",
    border: "dt_card",
    backgroundImage: `url(${watch.poster_url})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    objectFit: "cover",
    minHeight: "180px",
    maxHeight: "200px",
    borderRadius: "dt_radius_s",
    paddingY: "dt_s",
    paddingX: "dt_m",
    margin: "dt_s",
    cursor: "pointer",
    position: "relative",
    ":before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "dt_content_primary",
      opacity: 0.4,
      borderRadius: "dt_radius_s",
      zIndex: 1,
    },
    "@media (max-width: 320px)": {
      backgroundSize: "100% 100%",
    },
    "@media (max-width: 375px)": {
      backgroundSize: "100% 100%",
    },
    "@media (max-width: 414px)": {
      backgroundSize: "100% auto",
    },
    "@media (max-width: 768px)": {
      backgroundSize: "100% auto",
      ":not(:last-child)": {
        marginBottom: "dt_s",
      },
    },
  };
}
